import axios from 'axios'

export const isBrowser = () => typeof window !== "undefined"
export const logInWithFacebook = (redirectPath, createDiscount = false) => {
  window.location.href = `${process.env.BACKEND_URL}api/auth/facebook/signin?redirect_path=${encodeURIComponent(redirectPath)}${createDiscount ? '&create_discount=true' : ''}`
}
export const logInWithGoogle = (redirectPath, createDiscount = false) => {
  window.location.href = `${process.env.BACKEND_URL}api/auth/google/signin?redirect_path=${encodeURIComponent(redirectPath)}${createDiscount ? '&create_discount=true' : ''}`
}
export const signUpLocal = (accountInfo, redirectPath, errorHandler, createDiscount = false, callback) => {
  axios.post(
    `${process.env.BACKEND_URL}api/users${createDiscount ? '?create_discount=true' : ''}`,
    accountInfo
  )
  .then(res => {
    if (redirectPath) {
      window.location.href = redirectPath
    } else {
      callback && callback()
    }
  })
  .catch((err) => {
    errorHandler && errorHandler(err)
  })
}
export const logInLocal = (credentials, redirectPath, errorHandler) => {
  axios
    .post(`${process.env.BACKEND_URL}api/auth/signin`,
      credentials
    )
    .then(res => {
      window.location.href = redirectPath
    })
    .catch((err) => {
      errorHandler && errorHandler(err)
    })
}
export const handleLogin = callback => {
  axios.get(`${process.env.BACKEND_URL}api/users/me`)
  .then((res) => {
    callback && callback(res.data)
  })
  .catch(() => {
    callback(null)
  })
}
export const handleLogout = callback => {
  axios.post(`${process.env.BACKEND_URL}api/auth/logout`, {})
  .then(res => {
    callback && callback(true)
  })
  .catch(() => {
    callback && callback(false)
  })
}
